export default "__VITE_ASSET__Cd0H$aHe__"